import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { sortedUniq as _sortedUniq } from 'lodash-es';
import { API_STATUS, isComplete } from 'store/constants';
import { fetchSessionLookup } from './sessionLookupAPI';

const initialState = {
	data: {},
	status: API_STATUS.PENDING,
	levelsList: [],
	locationsList: [],
	statusesList: [],
	audienceList: [],
	sessionTypesList: []
};

// thunk & service
export const getSessionLookupAsync = createAsyncThunk('sessionLookup/fetchSessionLookup', async () => {
	const sessionLookupData = await fetchSessionLookup();
	return sessionLookupData;
});

export const sessionLookupSlice = createSlice({
	name: 'sessionLookup',
	initialState,
	reducers: {
		setSessionLookup: (state, action) => {
			// TODO
		}
	},

	extraReducers: builder => {
		builder
			.addCase(getSessionLookupAsync.pending, state => {
				state.status = API_STATUS.PENDING;
			})
			.addCase(getSessionLookupAsync.rejected, state => {
				state.status = API_STATUS.REJECTED;
			})
			.addCase(getSessionLookupAsync.fulfilled, (state, { payload }) => {
				state.data = { ...payload };

				state.levelsList = _sortedUniq(payload.levels);
				state.locationsList = _sortedUniq(payload.locations);
				state.statusesList = _sortedUniq(payload.statuses);
				state.audienceList = _sortedUniq(payload.targetAudiences);
				state.sessionTypesList = _sortedUniq(payload.types);

				state.status = API_STATUS.COMPLETED;
			});
	}
});

export const selectSessionLookupLoaded = state => isComplete(state.sessionLookup.status);

export const selectLevels = state => state.sessionLookup.levelsList;
export const selectLocation = state => state.sessionLookup.locationsList;
export const selectStatuses = state => state.sessionLookup.statusesList;
export const selectAudience = state => state.sessionLookup.audienceList;
export const selectAllSessionTypes = state => state.sessionLookup.sessionTypesList;
export const selectSessionTypes = state => state.sessionLookup.sessionTypesList.filter(type => type !== 'All');

export const { setSessionLookup } = sessionLookupSlice.actions;

export default sessionLookupSlice.reducer;
